export default "__VITE_ASSET__SE7qFafS__"